export default __webpack_public_path__ + "static/media/Acoer-404-asset-v3.430595cb.svg";